export enum AuthStatus {
   Loading,
   SignedIn,
   SignedOut,
}
